import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { GESTURE } from '@config/constants';

interface Settings {
  pluckMinVelocity: number;
  pluckMinVelocityLeft: number;
  pluckMinVelocityRight: number;
  bendDeadzone: number;
  bendFullRange: number;
  bendMaxCents: number;
  bendAlignThreshold: number;
  bendExtendedThreshold: number;
  modeStickinessMs: number;
  mirrorCamera: boolean;
  showHandOverlay: boolean;

  setPartial: (patch: Partial<Omit<Settings, 'setPartial' | 'reset'>>) => void;
  reset: () => void;
}

const DEFAULTS = {
  // All three mirror the same value now — both hands share one
  // sensitivity setting. L/R are retained in the schema for
  // persisted-settings back-compat and read via the single UI slider.
  pluckMinVelocity: GESTURE.PLUCK_MIN_VELOCITY,
  pluckMinVelocityLeft: GESTURE.PLUCK_MIN_VELOCITY,
  pluckMinVelocityRight: GESTURE.PLUCK_MIN_VELOCITY,
  bendDeadzone: GESTURE.BEND_ANCHOR_DEADZONE,
  bendFullRange: GESTURE.BEND_FULL_RANGE,
  bendMaxCents: GESTURE.BEND_MAX_CENTS,
  bendAlignThreshold: GESTURE.BEND_ALIGN_THRESHOLD,
  bendExtendedThreshold: GESTURE.BEND_EXTENDED_THRESHOLD,
  modeStickinessMs: GESTURE.MODE_STICKINESS_MS,
  mirrorCamera: true,
  showHandOverlay: true,
};

export const useSettingsStore = create<Settings>()(
  persist(
    (set) => ({
      ...DEFAULTS,
      setPartial: (patch) => set((s) => ({ ...s, ...patch })),
      reset: () => set({ ...DEFAULTS }),
    }),
    // v5: unified pluck sensitivity across both hands (previously
    // L=0.06 / R=0.10). Bump discards persisted asymmetric values.
    { name: 'adt3.settings', version: 5 },
  ),
);
